angular.module('bmsApp.merrymaids').factory('MMCustomerInactiveReasonSvc', function ($q,
																					 CRUDSvc) {

	var self = {
		options: function () {
			return CRUDSvc.get('api/customerInactiveReason/options');
		}

	};
	return self;

});
